export const caseDetailDiv = (key: string, themeStyles: string) =>
  `&#8202;<div class="mceNonEditable" data-case-detail="${key}" style="${themeStyles}">{$${key}}</div>&#8202;`

export default caseDetailDiv
